var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "md-layout" }, [
      _c(
        "div",
        { staticClass: "md-layout-item" },
        [
          _c("div", { staticClass: "custom-toolbar" }, [
            _c(
              "div",
              { staticClass: "custom-toolbar-start" },
              [
                !_vm.showCarrierOrders || _vm.activeTab !== "Booked to Carrier"
                  ? _c("OrderFilterMenu", {
                      on: { handleFilterChange: _vm.handleFilterChange },
                    })
                  : _vm._e(),
                _vm.showCarrierOrders && _vm.activeTab === "Booked to Carrier"
                  ? _c("ManifestTableFilters", {
                      attrs: {
                        "initial-from-date": _vm.manifestFromDate,
                        "initial-to-date": _vm.manifestToDate,
                      },
                      on: { "filter-changed": _vm.handleManifestFilterChange },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "custom-toolbar-end" },
              [
                _vm.$root.isDesktop &&
                (!_vm.showCarrierOrders ||
                  _vm.activeTab !== "Booked to Carrier")
                  ? _c("search-component", {
                      attrs: {
                        "search-filter": _vm.currentSearchTextValue,
                        "handle-search-on-type": true,
                      },
                      on: { onSearch: _vm.handleFilterOrSearch },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "md-card",
            { staticClass: "custom-margin-bottom" },
            [
              _c(
                "md-card-header",
                { staticClass: "md-card-header-icon md-card-header-warning" },
                [
                  _c(
                    "div",
                    { staticClass: "card-icon" },
                    [_c("md-icon", [_vm._v("receipt_long")])],
                    1
                  ),
                ]
              ),
              _c("orders-table-header-actions", {
                attrs: {
                  "selected-order-ids": _vm.selectedOrders.map(function (x) {
                    return x.orderId
                  }),
                  "top-scroll-position": _vm.topScrollPosition,
                  "actions-to-display": _vm.tableHeaderActionsToDisplay,
                },
                on: {
                  "scheduling-link-button-clicked": _vm.sendSchedulingLink,
                  "ready-for-packing-button-clicked":
                    _vm.handleReadyForPackingClicked,
                  "batch-assign-clicked": _vm.handleBatchAssignClicked,
                  "book-now-button-clicked": _vm.handleBookNowClicked,
                },
              }),
              !_vm.showCarrierOrders
                ? [
                    _c("orders-table", {
                      attrs: {
                        "order-list": _vm.orderList,
                        "is-list-loading": _vm.isListLoading,
                        "show-carrier-orders": _vm.showCarrierOrders,
                        "selected-orders": _vm.selectedOrders,
                        "column-dropdown-options": _vm.columnDropdownOptions,
                        "selected-column": _vm.selectedColumn,
                        "is-disabled": _vm.isDisabled,
                        "table-body-actions-to-display":
                          _vm.tableBodyActionsToDisplay,
                        "can-assign-carrier": _vm.canAssignCarrier,
                        "loading-orders": _vm.loadingOrders,
                        "order-rates-fetch-status": _vm.orderRatesFetchStatus,
                      },
                      on: {
                        "select-all-changed": _vm.onSelectAll,
                        "single-checkbox-changed": _vm.singleCheckbox,
                        "column-selected": _vm.handleSelectedColumn,
                        "assigned-carrier-changed":
                          _vm.handleAssignedCarrierChanged,
                        "update-order": _vm.updateOrder,
                        "delete-order": _vm.handleDelete,
                        "put-order-on-hold": _vm.putOrderOnHold,
                        "cancel-order": _vm.cancelOrder,
                        "download-label-clicked":
                          _vm.handleDownloadLabelButtonClicked,
                      },
                    }),
                  ]
                : _c(
                    "md-card-content",
                    { staticClass: "body-list" },
                    [
                      _c(
                        "tabs",
                        {
                          staticClass: "custom-tab-list",
                          attrs: {
                            "tab-name": _vm.tabNames,
                            "color-button": "success",
                            "selected-panel": _vm.activeTab,
                          },
                          on: { "switch-panel": _vm.switchTab },
                        },
                        [
                          _vm._l(_vm.tabNames, function (tabName, index) {
                            return _c(
                              "template",
                              { slot: "tab-pane-" + (index + 1) },
                              [
                                _vm.isListLoading
                                  ? [_c("skeleton-table", { key: index })]
                                  : [
                                      _vm.activeTab === "Booked to Carrier"
                                        ? [
                                            _c("carrier-manifests-table", {
                                              key: index,
                                              attrs: {
                                                manifests: _vm.manifests,
                                              },
                                              on: {
                                                "download-labels":
                                                  _vm.handleDownloadLabelsForManifest,
                                              },
                                            }),
                                          ]
                                        : _c("orders-table", {
                                            key: tabName,
                                            attrs: {
                                              "order-list": _vm.orderList,
                                              "show-carrier-orders":
                                                _vm.showCarrierOrders,
                                              "selected-orders":
                                                _vm.selectedOrders,
                                              "column-dropdown-options":
                                                _vm.columnDropdownOptions,
                                              "selected-column":
                                                _vm.selectedColumn,
                                              "is-disabled": _vm.isDisabled,
                                              "table-body-actions-to-display":
                                                _vm.tableBodyActionsToDisplay,
                                              "can-assign-carrier":
                                                _vm.canAssignCarrier,
                                              "loading-orders":
                                                _vm.loadingOrders,
                                              "order-rates-fetch-status":
                                                _vm.orderRatesFetchStatus,
                                            },
                                            on: {
                                              "select-all-changed":
                                                _vm.onSelectAll,
                                              "single-checkbox-changed":
                                                _vm.singleCheckbox,
                                              "column-selected":
                                                _vm.handleSelectedColumn,
                                              "assigned-carrier-changed":
                                                _vm.handleAssignedCarrierChanged,
                                              "update-order": _vm.updateOrder,
                                              "put-order-on-hold":
                                                _vm.putOrderOnHold,
                                              "cancel-order": _vm.cancelOrder,
                                              "download-label-clicked":
                                                _vm.handleDownloadLabelButtonClicked,
                                            },
                                          }),
                                    ],
                              ],
                              2
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
            ],
            2
          ),
          _c(
            "md-card-actions",
            {
              staticClass: "page-footer",
              attrs: { "md-alignment": "space-between" },
            },
            [
              _c("div", [
                _vm.total === _vm.pagination.perPage
                  ? _c("p", { staticClass: "card-category" }, [
                      _vm._v(
                        "\n                        Page " +
                          _vm._s(_vm.pagination.currentPage) +
                          " of many\n                    "
                      ),
                    ])
                  : _c("p", { staticClass: "card-category" }, [
                      _vm._v(
                        "Page " +
                          _vm._s(_vm.pagination.currentPage) +
                          " of " +
                          _vm._s(_vm.totalPages)
                      ),
                    ]),
              ]),
              _c("pagination", {
                staticClass: "pagination-no-border pagination-success",
                attrs: { "per-page": _vm.pagination.perPage, total: _vm.total },
                on: {
                  "change-page": function ($event) {
                    return _vm.handleChangePage($event, _vm.pagination.perPage)
                  },
                },
                model: {
                  value: _vm.pagination.currentPage,
                  callback: function ($$v) {
                    _vm.$set(_vm.pagination, "currentPage", $$v)
                  },
                  expression: "pagination.currentPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }